import React from 'react'
import { Dropdown } from 'react-bootstrap';

const LowerBarCategory = () => {
    return (
        <>
            <Dropdown className='all-cat'>
                <Dropdown.Toggle  id="dropdown-basic">
                    Dropdown Button
                    <span style={{marginLeft:'5px'}}>
                        <i className="fa fa-bars" />
                    </span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                    <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </>
    )
}

export default LowerBarCategory;